"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _getMelbourneTimezoneMoment = _interopRequireDefault(require("../get-melbourne-timezone-moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var timezonePlaceholderSerializer = function timezonePlaceholderSerializer(_ref) {
  var placeholders = _ref.placeholders;
  return function (value) {
    var matchedPlaceholder = (0, _fp.find)({
      _id: (0, _fp.get)('node._ref', value)
    }, placeholders);
    var placeholderId = (0, _fp.get)('identifier.current', matchedPlaceholder);
    if (placeholderId === 'australian-eastern-time') {
      return (0, _getMelbourneTimezoneMoment["default"])().format('zz');
    }
    return '';
  };
};
var _default = exports["default"] = timezonePlaceholderSerializer;
module.exports = exports.default;